import { render, staticRenderFns } from "./PROrderInfo.vue?vue&type=template&id=2db189c2&"
import script from "./PROrderInfo.vue?vue&type=script&lang=js&"
export * from "./PROrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports